import React from 'react';
import {
    Typography,
    makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    titulo: {
        color: theme.palette.primary.main,
        margin: '10px 0 0 10px'
    }
}));

function Titulo(
    {
        texto
    }
) {
    const classes = useStyles();

    return <Typography variant='subtitle1'
        className={classes.titulo}>
        {texto}
    </Typography>
}

export default Titulo;